import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveSupplierInventoryImportStatus } from './index';

// Api's
import { supplierInventoryImportStatusApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getSupplierInventoryImportStatusSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      supplierInventoryImportStatusApi.getDomain
    );

    if (response.data.result) {
      yield put(saveSupplierInventoryImportStatus(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveSupplierInventoryImportStatus(null, true, resultError.messagesDataError));
    }
  }
}
